export const SIGN_NAMES = {
  ARIES: 'aries',
  TAURUS: 'taurus',
  GEMINI: 'gemini',
  CANCER: 'cancer',
  LEO: 'leo',
  VIRGO: 'virgo',
  LIBRA: 'libra',
  SCORPIO: 'scorpio',
  SAGITTARIUS: 'sagittarius',
  CAPRICORN: 'capricorn',
  AQUARIUS: 'aquarius',
  PISCES: 'pisces'
}

export const SIGNS = {
  [SIGN_NAMES.ARIES]: {
    guid: 'beran',
    name: 'Beran',
    date: '21.3. - 20.4.'
  },
  [SIGN_NAMES.TAURUS]: {
    guid: 'byk',
    name: 'Býk',
    date: '21.4. - 21.5.'
  },
  [SIGN_NAMES.GEMINI]: {
    guid: 'blizenci',
    name: 'Blíženci',
    date: '22.5. - 21.6.'
  },
  [SIGN_NAMES.CANCER]: {
    guid: 'rak',
    name: 'Rak',
    date: '22.6. - 22.7.'
  },
  [SIGN_NAMES.LEO]: {
    guid: 'lev',
    name: 'Lev',
    date: '23.7. - 22.8.'
  },
  [SIGN_NAMES.VIRGO]: {
    guid: 'panna',
    name: 'Panna',
    date: '23.8. - 22.9.'
  },
  [SIGN_NAMES.LIBRA]: {
    guid: 'vahy',
    name: 'Váhy',
    date: '23.9. - 23.10.'
  },
  [SIGN_NAMES.SCORPIO]: {
    guid: 'stir',
    name: 'Štír',
    date: '24.10. - 22.11.'
  },
  [SIGN_NAMES.SAGITTARIUS]: {
    guid: 'strelec',
    name: 'Střelec',
    date: '23.11. - 21.12.'
  },
  [SIGN_NAMES.CAPRICORN]: {
    guid: 'kozoroh',
    name: 'Kozoroh',
    date: '22.12. - 20.1.'
  },
  [SIGN_NAMES.AQUARIUS]: {
    guid: 'vodnar',
    name: 'Vodnář',
    date: '21.1. - 20.2.'
  },
  [SIGN_NAMES.PISCES]: {
    guid: 'ryby',
    name: 'Ryby',
    date: '21.2. - 20.3.'
  }
}

export const SIGN_INTERVALS = [
  {
    1: SIGN_NAMES.CAPRICORN,
    21: SIGN_NAMES.AQUARIUS
  },
  {
    1: SIGN_NAMES.AQUARIUS,
    21: SIGN_NAMES.PISCES
  },
  {
    1: SIGN_NAMES.PISCES,
    21: SIGN_NAMES.ARIES
  },
  {
    1: SIGN_NAMES.ARIES,
    21: SIGN_NAMES.TAURUS
  },
  {
    1: SIGN_NAMES.TAURUS,
    22: SIGN_NAMES.GEMINI
  },
  {
    1: SIGN_NAMES.GEMINI,
    22: SIGN_NAMES.CANCER
  },
  {
    1: SIGN_NAMES.CANCER,
    23: SIGN_NAMES.LEO
  },
  {
    1: SIGN_NAMES.LEO,
    23: SIGN_NAMES.VIRGO
  },
  {
    1: SIGN_NAMES.VIRGO,
    23: SIGN_NAMES.LIBRA
  },
  {
    1: SIGN_NAMES.LIBRA,
    24: SIGN_NAMES.SCORPIO
  },
  {
    1: SIGN_NAMES.SCORPIO,
    23: SIGN_NAMES.SAGITTARIUS
  },
  {
    1: SIGN_NAMES.SAGITTARIUS,
    22: SIGN_NAMES.CAPRICORN
  }
]

export const SIGNS_LIST = [
  SIGN_NAMES.ARIES,
  SIGN_NAMES.TAURUS,
  SIGN_NAMES.GEMINI,
  SIGN_NAMES.CANCER,
  SIGN_NAMES.LEO,
  SIGN_NAMES.VIRGO,
  SIGN_NAMES.LIBRA,
  SIGN_NAMES.SCORPIO,
  SIGN_NAMES.SAGITTARIUS,
  SIGN_NAMES.CAPRICORN,
  SIGN_NAMES.AQUARIUS,
  SIGN_NAMES.PISCES
]
